<div class="page-content page-fill">
  <div class="card mb-3">
    @if (!proposalInfo) {
      <div>No Proposal Found</div>
    }
    @if (proposalInfo) {
      <div class="card-body">
        <div class="m-3">
          <h2>Code {{ userCode }}</h2>
        </div>
        <div class="m-3">
          <h2>
            Proposal
            <h3>From: {{ proposalInfo.FromCommittee }} To: {{ proposalInfo.ToCommittee }}</h3>
          </h2>
          @if (proposalInfo) {
            <div class="m-3" style="max-width: 850px">
              <strong> {{ proposalInfo.Message }}</strong>
              @if (proposalInfo && proposalInfo.Notes) {
                <div>Notes: {{ proposalInfo.Notes }}</div>
              }
            </div>
          }
        </div>
        <button class="mt-3 ms-4 btn btn-success {{proposalInfo.Voted && proposalInfo.YesVote ? ' border-class' : ''}}" (click)="submitVote('Yes')" [hidden]="voteClosed">Vote Yes</button>
        <button class="mt-3 ms-4 btn btn-danger {{proposalInfo.Voted && !proposalInfo.YesVote ? ' border-class' : ''}}" (click)="submitVote('No')" [hidden]="voteClosed">Vote No</button>
        @if (proposalInfo && proposalInfo.Voted) {
          <div class="m-3">
            You voted {{proposalInfo.YesVote ? 'YES' : 'NO'}} on {{proposalInfo.voteDate}}
          </div>
        }
        @if (proposalInfo && canDiscuss) {
          <div class="m-3" style="max-width: 100%">
            Discussion
            <dx-text-area [(value)]="discussion" [height]="'100px'"></dx-text-area>
          </div>
        }
        <button class="ms-3 btn btn-primary" (click)="addDiscussion()" [hidden]="!canDiscuss || voteClosed">Add Discussion</button>
        @if (proposalInfo && discussions.length > 0) {
          <div>
            <table class="table mt-3">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Note</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                @for (note of discussions; track note) {
                  <tr>
                    <td class="col-xs-5">{{ note.Name }}</td>
                    <td class="col-xs-5">{{ note.Note }}</td>
                    <td class="col-xs-1">{{ note.date }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (proposalInfo && proposalInfo.Voted) {
          <div class="m-3">
            <h3>Thanks for voting!</h3>
          </div>
        }
        @if (proposalInfo && (proposalInfo.Approved || proposalInfo.Declined || proposalInfo.Voted)) {
          <div class="m-3">
            <h3>The motion{{ proposalInfo.Approved ? ' was APPROVED' : proposalInfo.Declined ? ' was DECLINED' : ' is still open for voting' }}</h3>
          </div>
        }
      </div>
    }
  </div>
</div>
